import Make from './../components/MakeSection/Make';
import FAQs from '../components/FAQsSection/FAQs';
import ServicesSection from '../components/ServicesSection/ServicesSection';
import History from '../components/HistorySection/History';
import Description from '../components/DescriptionSection/Description';
import HeroSection from '../components/HeroSection/HeroSection';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const ServicesCompanies = () => {
  const seo = usePageSEO('servicesCompanies');

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <HeroSection page="ServicesPage" showRecentWork={false} showMoreButton={true} />
      <ServicesSection page="ServicesCompaniesPage" />
      <History pageKey="ServicesCompanies" />
      <Description page="ServicesCompaniesPage" />
      <FAQs page='servicesPage' />
      <Make pageKey='ServicesCompaniesPage' />
    </>
  );
};

export default ServicesCompanies;